export function isRenderableSectionConfig(config) {
  return Boolean(config?.blocks?.length);
}
